import styled from "styled-components";

export const Container = styled.div`
    max-width: 220px;
    width: 100%;
    /* max-height: 282px; */
    /* height: 100%; */
    padding: ${props => props.theme.paddings.more_less_big};
    display:flex;
    flex-direction: column;
    background: ${props => props.theme.backgrounds.white};
    border:${props=> props.border? props.theme.border.large_red2 : props.theme.border.very_large} ;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
    border-radius: 18px;
    margin: 10px;
    cursor:pointer;
`;

export const OrderId = styled.div`
    width:100%;
    margin-bottom: 17px;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.medium};
    line-height: ${props => props.theme.lines_height.large};
    color: ${props => props.theme.colors.gray};
    display:flex;
    gap:${props => props.theme.gaps.very_small};
    flex-direction:column;
    justify-content: center;
    align-items:center;
`;

export const timerOrder = styled.div`
    width: 100%;
    display:flex;
    gap:${props => props.theme.gaps.very_small};
    justify-content:center;
    align-items: center;
    color:${props=>props.isLate ? props.theme.colors.red2 :'#717171'};
`;

export const OrderStatus = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    height: 34px;
    border-radius: 33px;
    padding: 8px 16px;
    color:${props=>props.color === '#F2F2F2' ? '#717171': props.theme.colors.white};
    font-weight: ${props => props.theme.font_weight.large} ;
    font-size: ${props => props.theme.font_size.small};
    line-height: ${props => props.theme.lines_height.medium};
    background-color: ${props=>props.color};

    p{
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden; 
    }
`;

export const AdressWrapper = styled.div`
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.gaps.small} ;
    margin-top: ${props => props.theme.margins.small} ;
`;

export const IconCard = styled.img`
    width:20px;
    height:20px;
`;

export const Adress = styled.div`
    min-width:162px;
    width:100%;
    height: 42px;
    display: -webkit-box;
    align-items: center;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.very_small};
    line-height: ${props => props.theme.lines_height.small} ;
    justify-content: flex-start;
    color: ${props => props.theme.colors.black};

    p{
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden; 
     }
`;

export const Client = styled.div`
    min-width:162px;
    width:100%;
    height: 42px;
    display: -webkit-box;
    align-items: center;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.very_small};
    line-height: ${props => props.theme.lines_height.small} ;
    justify-content: flex-start;
    color: ${props => props.theme.colors.black};
`;

export const WrapperClient = styled.div`
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.gaps.small} ;
    margin-top: ${props => props.theme.margins.small} ;
`;

export const Origin = styled.div`
    width: 140px;
    display: flex;
    align-items: center;
    border-radius: 45px;
    background: ${props => props.theme.backgrounds.gray7};
    padding: 6px 12px;
    gap: ${props => props.theme.gaps.small};
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.small};
    line-height: ${props => props.theme.lines_height.medium};
    color: ${props => props.theme.colors.gray3} ;
    margin-top:8px;
`;
export const NewOrderTag = styled.div`
    justify-content: center;
    align-items: center;
    padding: 8px 12px;
    gap: ${props => props.theme.gaps.small};
    width: 62px;
    margin-top:8px;

    background: ${props => props.theme.backgrounds.red2};
    border-radius: 65px;
    font-weight: ${props => props.theme.font_weight.large};
    font-size: ${props => props.theme.font_size.very_small};    
    line-height: ${props => props.theme.lines_height.small};
    color: ${props => props.theme.colors.white};
`;

export const BottomStatus = styled.div`
    width: 100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
`;

export const DeliveryForm = styled(Origin)` 
    margin-top:${props => props.theme.margins.small};
`;